import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxFileDropEntry } from "ngx-file-drop";
import { SaveFormService } from "../services/save-form.service";
import { CreateRegisterRequestDto } from "../models/register.models";
import { FileNameAndBase64, UpdateContactingDto } from "../../../support/models/support.models";
import { FilesToStringService } from "../../../../services/files-to-string.service";
import { LoginCredentialsDto } from "../../../../models/auth/auth.model";
import { Observable, tap } from "rxjs";
import jwt_decode from "jwt-decode";
import { RegisterFormDataService } from "../services/register-form-data.service";
import { NotificationService } from "../../../../services/notification.service";

@Component({
	selector: "app-agreement",
	templateUrl: "./agreement.component.html",
	styleUrls: ["./agreement.component.scss"],
})
export class AgreementComponent implements OnInit {
	personalData = false;
	agreement = false;

	maxSymbol = 250;
	commentText = "";

	isSending = false;

	isNotDownloadFile = false;

	constructor(
		private router: Router,
		private saveFormService: SaveFormService,
		private filesToStringService: FilesToStringService,
		private registerFormDataService: RegisterFormDataService,
		private notificationService: NotificationService
	) {}

	ngOnInit() {
		this.initForm();
	}

	initForm() {
		if (localStorage.hasOwnProperty("form")) {
			this.commentText = this.saveFormService.getFormData().agreement.comment;
		} else {
			this.saveFormService.initFormLocalStorage();
		}
	}

	public files: NgxFileDropEntry[] = [];

	public dropped(files: NgxFileDropEntry[]) {
		for (const droppedFile of files) {
			const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
			fileEntry.file((file: File) => {
				const type = file.name.substring(file.name.indexOf(".") + 1);
				const allowedTypes = ["jpg", "jpeg", "bmp", "gif", "png", "doc", "docx", "pdf", "xlsx", "xls", "rar", "zip"];
				if (file.size / 1048576 <= 10 && this.files.length <= 4 && allowedTypes.includes(type.toLocaleLowerCase())) {
					this.files.push(droppedFile);
				} else {
					this.notificationService.setConfiguration("icon-6", "error", "AGREEMENT.NOTIFICATION.TITLE", [
						"AGREEMENT.NOTIFICATION.DESCRIPTION",
						"AGREEMENT.NOTIFICATION.DESCRIPTION_1",
						"AGREEMENT.NOTIFICATION.DESCRIPTION_2",
						"AGREEMENT.NOTIFICATION.DESCRIPTION_3",
					]);
					this.notificationService.showNotification();
				}
			});
		}
	}

	public fileOver(event: any) {}

	public fileLeave(event: any) {}

	deleteFile(index: number) {
		this.files.splice(index, 1);
	}

	saveData() {
		this.saveFormService.saveComment(this.commentText);
	}

	sendForm() {
		this.isSending = true;
		const formData = this.saveFormService.getFormData();

		if (!formData.personalData.surname || !formData.personalData.firstname || !formData.personalData.phone) {
			this.router.navigate(["/register/personal-data"]);
			return;
		}

		if (
			!formData.companyData.companyName ||
			!formData.companyData.phone ||
			!formData.companyData.email ||
			!formData.companyData.bin ||
			!formData.companyData.phone ||
			!formData.companyData.type
		) {
			this.router.navigate(["/register/company-data"]);
			return;
		}

		if (
			!formData.companyAddress.index ||
			!formData.companyAddress.city ||
			!formData.companyAddress.area ||
			!formData.companyAddress.street ||
			!formData.companyAddress.house ||
			!formData.companyAddress.office
		) {
			this.router.navigate(["/register/address-company"]);
			return;
		}

		if (!formData.products.productList) {
			this.router.navigate(["/register/products"]);
			return;
		}

		this.filesToStringService.toFilesBase64(this.files).subscribe({
			next: (res) => {
				const data: CreateRegisterRequestDto = {
					full_name: `${formData.personalData.surname} ${formData.personalData.firstname} ${formData.personalData.lastname}`,
					agent_name: formData.companyData.companyName,
					email: formData.companyData.email,
					phonenumber: formData.companyData.phone,
					work_phonenumber: formData.companyData.phone,
					activity_type: formData.companyData.type,
					bin: formData.companyData.bin,
					postcode: formData.companyAddress.index,
					district: formData.companyAddress.area,
					street: formData.companyAddress.street,
					building: formData.companyAddress.house,
					flat: formData.companyAddress.office,
					services: formData.products.productList.split(","),
					comment: this.commentText,
					city: formData.companyAddress.city,
					files: res,
				};

				this.registerFormDataService.uploadRequest(data).subscribe({
					next: () => {
						this.isSending = false;
						this.router.navigate(["/register/success"]);
					},
					error: () => {
						this.isSending = false;
					},
				});
			},
		});
	}
}
